import React from 'react'
import BalanceIcon from 'react-icons/lib/fa/balance-scale'
import Tooltip from 'orionsoft-parts/lib/components/Tooltip'
import {useInboxConfiguration} from '../../Configuration/hooks'

export default function BalancerStatus() {
  const {configuration} = useInboxConfiguration()

  const states = {
    off: {
      label: 'Apagado',
      color: 'red'
    },
    on: {
      label: 'Encendido',
      color: '#1bb157'
    },
    'on-orders': {
      label: 'Encendido para chats con pedido activo',
      color: '#d3a541'
    }
  }

  let status = 'off'
  if (configuration.balancerEnabled && configuration.onlyAcceptsChatsWithActiveOrder) {
    status = 'on-orders'
  } else if (configuration.balancerEnabled) {
    status = 'on'
  }

  const balancerState = states[status]

  return (
    <Tooltip place="right" content={<div>Estado del balanceador: {balancerState.label}</div>}>
      <BalanceIcon size="30" color={balancerState.color} />
    </Tooltip>
  )
}
